/* Delecora — product page behaviour */
(function () {
  'use strict';

function initProduct() {
  var root = document.querySelector('[data-product-root]');
  if (!root || root.dataset.bound === '1') return;
  root.dataset.bound = '1';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var CFG = window.Delecora || {};
  var money = window.delecoraFormatMoney || function (c) { return c; };
  var toast = window.delecoraToast || function () {};

  var variantsScript = $('[data-product-variants]');
  var variants = [];
  try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

  var form = $('#productForm');
  var variantInput = $('[data-variant-input]');
  var quantityInput = $('[data-quantity-input]');
  var addBtn = $('#addBag');
  var addText = $('[data-add-text]');
  var buyNow = $('#buyNow');

  var qty = 1;
  var activeImg = 0;

  /* ---------- Gallery ---------- */
  var thumbs = $$('#thumbs .thumb');
  var mainImg = $('#mainImg');

  function setMain(i) {
    var t = thumbs[i];
    if (!t || !mainImg) return;
    activeImg = i;
    thumbs.forEach(function (x, n) { x.classList.toggle('active', n === i); });
    mainImg.src = t.getAttribute('data-full');
    mainImg.removeAttribute('srcset');
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { setMain(i); });
  });

  /* ---------- Lightbox ---------- */
  var lb = $('#lightbox');
  var lbImg = $('#lbImg');
  var lbCount = $('#lbCount');
  var lbThumbs = $('#lbThumbs');
  var lbPrev = $('#lbPrev');
  var lbNext = $('#lbNext');
  var lbStage = $('#lbStage');
  var lbIdx = 0;
  var lbSrcs = thumbs.map(function (t) { return t.getAttribute('data-full'); });

  function lbPaint() {
    if (!lbSrcs.length || !lbImg) return;
    lbImg.src = lbSrcs[lbIdx];
    lbImg.alt = document.title + ' - image ' + (lbIdx + 1);
    if (lbCount) lbCount.textContent = (lbIdx + 1) + ' / ' + lbSrcs.length;
    var multi = lbSrcs.length > 1;
    if (lbPrev) lbPrev.style.display = multi ? 'grid' : 'none';
    if (lbNext) lbNext.style.display = multi ? 'grid' : 'none';
    if (lbThumbs) {
      lbThumbs.style.display = multi ? 'flex' : 'none';
      $$('.lb-thumb', lbThumbs).forEach(function (t, i) { t.classList.toggle('active', i === lbIdx); });
    }
  }

  function openLightbox(i) {
    if (!lb || !lbSrcs.length) return;
    lbIdx = Math.max(0, Math.min(i || 0, lbSrcs.length - 1));
    if (lbThumbs) {
      lbThumbs.innerHTML = lbSrcs.map(function (src, n) {
        return '<button class="lb-thumb" data-i="' + n + '" type="button" aria-label="Image ' + (n + 1) + '"><img src="' + src + '" alt=""></button>';
      }).join('');
    }
    lbPaint();
    lb.classList.add('show');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('show');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function lbGo(step) {
    if (!lbSrcs.length) return;
    lbIdx = (lbIdx + step + lbSrcs.length) % lbSrcs.length;
    lbPaint();
  }

  if (mainImg) mainImg.addEventListener('click', function () { openLightbox(activeImg); });
  var zoomBtn = $('#zoomBtn');
  if (zoomBtn) zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(activeImg); });

  /* ---------- Hover-to-magnify (desktop / mouse only — touch devices get
     the full-screen lightbox above, plus native pinch-zoom inside it). ---------- */
  var mainMedia = $('.main-media');
  if (mainMedia && mainImg && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var ZOOM_SCALE = 2.2;
    mainMedia.addEventListener('mouseenter', function () {
      var full = thumbs[activeImg] && thumbs[activeImg].getAttribute('data-full');
      if (full && mainImg.src !== full) {
        mainImg.src = full;
        mainImg.removeAttribute('srcset');
      }
      mainImg.style.transition = 'none';
    });
    mainMedia.addEventListener('mousemove', function (e) {
      var r = mainMedia.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      mainImg.style.transformOrigin = x + '% ' + y + '%';
      mainImg.style.transform = 'scale(' + ZOOM_SCALE + ')';
    });
    mainMedia.addEventListener('mouseleave', function () {
      mainImg.style.transition = 'transform .25s ease';
      mainImg.style.transform = 'scale(1)';
    });
  }
  var lbClose = $('#lbClose');
  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbGo(-1); });
  if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbGo(1); });
  if (lbThumbs) {
    lbThumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.lb-thumb');
      if (b) { lbIdx = Number(b.dataset.i); lbPaint(); }
    });
  }
  if (lb) {
    lb.addEventListener('click', function (e) {
      if (e.target.id === 'lightbox' || e.target.id === 'lbStage') closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('show')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lbGo(-1);
    if (e.key === 'ArrowRight') lbGo(1);
  });

  if (lbStage) {
    var startX = null;
    lbStage.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
    lbStage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) lbGo(dx < 0 ? 1 : -1);
      startX = null;
    }, { passive: true });
  }

  /* ---------- Variant picker ---------- */
  function selectedOptions() {
    var values = [];
    $$('[data-option-row]').forEach(function (row) {
      var active = row.querySelector('.active');
      values.push(active ? active.getAttribute('data-value') : null);
    });
    return values;
  }

  function findVariant(values) {
    if (!values.length) return variants[0];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] !== null && v.options[j] !== values[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant() {
    var values = selectedOptions();
    var variant = findVariant(values);

    $$('[data-option-label]').forEach(function (label, i) {
      if (values[i]) label.textContent = values[i];
    });

    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var discountEl = $('[data-discount]');
    var taxMrp = $('[data-tax-mrp]');
    var stockWrap = $('[data-stock]');
    var stockText = $('[data-stock-text]');

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = CFG.strings ? CFG.strings.soldOut : 'Unavailable';
      if (buyNow) buyNow.disabled = true;
      if (stockWrap) stockWrap.classList.add('out');
      if (stockText) stockText.textContent = 'Unavailable';
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.textContent = onSale ? money(variant.compare_at_price) : '';
      compareEl.hidden = !onSale;
    }
    if (discountEl) {
      discountEl.textContent = onSale
        ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '% off'
        : '';
      discountEl.hidden = !onSale;
    }
    if (taxMrp) taxMrp.textContent = onSale ? money(variant.compare_at_price) : '';

    if (addBtn) addBtn.disabled = !variant.available;
    if (buyNow) buyNow.disabled = !variant.available;
    if (addText) {
      addText.textContent = variant.available
        ? (CFG.strings ? CFG.strings.addToBag : 'Add to bag')
        : (CFG.strings ? CFG.strings.soldOut : 'Sold out');
    }
    if (stockWrap) stockWrap.classList.toggle('out', !variant.available);
    if (stockText) stockText.textContent = variant.available ? 'In stock — ready to ship' : 'Currently sold out';

    if (variant.featured_media) {
      var i = thumbs.findIndex(function (t) { return Number(t.getAttribute('data-media-id')) === variant.featured_media.id; });
      if (i > -1) setMain(i);
    }

    if (window.history.replaceState) {
      var url = root.getAttribute('data-product-url') + '?variant=' + variant.id;
      window.history.replaceState({}, '', url);
    }
  }

  /* ---------- Required size selection ---------- */
  var sizeRows = $$('[data-size-row]');
  var sizeChosen = sizeRows.length === 0; /* nothing to require if there's no size option */
  var sizeError = null;

  function clearSizeError() {
    sizeRows.forEach(function (row) { row.classList.remove('needs-size'); });
    if (sizeError) { sizeError.remove(); sizeError = null; }
  }

  function flagSizeRequired() {
    sizeRows.forEach(function (row) { row.classList.add('needs-size'); });
    if (!sizeError && sizeRows.length) {
      sizeError = document.createElement('p');
      sizeError.className = 'size-error';
      sizeError.setAttribute('role', 'alert');
      sizeError.textContent = CFG.strings && CFG.strings.selectSize ? CFG.strings.selectSize : 'Please select a size';
      sizeRows[sizeRows.length - 1].insertAdjacentElement('afterend', sizeError);
    }
    sizeRows[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  $$('[data-option-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('[data-option-row]');
      if (!row) return;
      $$('[data-option-value]', row).forEach(function (b) { b.classList.toggle('active', b === btn); });
      if (row.hasAttribute('data-size-row')) {
        sizeChosen = true;
        clearSizeError();
      }
      updateVariant();
    });
  });

  /* ---------- Quantity ---------- */
  var qtyVal = $('#qtyVal');
  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyVal) qtyVal.textContent = qty;
    if (quantityInput) quantityInput.value = qty;
  }
  var qtyMinus = $('#qtyMinus');
  var qtyPlus = $('#qtyPlus');
  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(qty - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(qty + 1); });

  /* ---------- Add to bag / Buy now ---------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || addBtn.disabled) return;
      if (!sizeChosen) { flagSizeRequired(); return; }
      var title = ($('.pdp-title') || {}).textContent || '';
      if (window.delecoraAddToCart) {
        addBtn.disabled = true;
        window.delecoraAddToCart(variantInput.value, qty, title.trim()).then(function () {
          addBtn.disabled = false;
        });
      }
    });
  }

  if (buyNow) {
    buyNow.addEventListener('click', function () {
      if (buyNow.disabled || !variantInput) return;
      if (!sizeChosen) { flagSizeRequired(); return; }
      if (!window.delecoraAddToCart) return;
      buyNow.disabled = true;
      window.delecoraAddToCart(variantInput.value, qty).then(function (ok) {
        if (ok) {
          window.location.href = (CFG.routes && CFG.routes.checkout) || '/checkout';
        } else {
          buyNow.disabled = false;
        }
      });
    });
  }

  /* ---------- Size chart modal ---------- */
  var scBtn = $('#sizeChartBtn');
  var scModal = $('#sizeChartModal');
  if (scBtn && scModal) {
    var scOpen = function () {
      scModal.classList.add('open');
      scModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    var scClose = function () {
      scModal.classList.remove('open');
      scModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    scBtn.addEventListener('click', scOpen);
    $$('[data-scm-close]', scModal).forEach(function (el) {
      el.addEventListener('click', scClose);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && scModal.classList.contains('open')) scClose();
    });
  }

  setQty(1);
  updateVariant();
}

  initProduct();
  /* The theme editor swaps section HTML without re-running injected scripts,
     so re-initialise against the fresh DOM. */
  document.addEventListener('shopify:section:load', initProduct);
})();
